module.exports = __webpack_public_path__ + "img/idea-edit-icon.6250962d.svg";